import React, { forwardRef } from 'react';
import cn from 'classnames';

const Input = forwardRef(
  (
    {
      value,
      defaultValue,
      placeholder,
      disabled,
      onChange,
      onKeyDownCapture,
      onBlur,
      className = {},
      type = 'text',
      multiline,
      paddingClassName = 'pl-4.2 pr-8.4',
      autoFocus = false,
      ...otherProps
    },
    ref,
  ) => {
    const inputProps = {
      className: cn(
        'w-full border border-gray-400',
        // smaller rounded corners for multiline
        multiline ? 'rounded-0.6' : 'rounded-24.8',
        // larger height for multiline
        multiline ? 'h-84' : 'h-12.2',
        { 'bg-gray-100': disabled },
        paddingClassName,
        className,
      ),
      type,
      // uncontrolled inputs don't like null, and react throws errors, so default to empty string
      value,
      defaultValue,
      placeholder,
      onBlur,
      onChange,
      onKeyDownCapture,
      disabled,
      autoFocus,
      ...otherProps,
    };
    if (multiline) {
      return <textarea {...inputProps} ref={ref} />;
    }
    return <input {...inputProps} ref={ref} />;
  },
);

export default Input;
